import React, { Fragment, useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { login, forgot } from "../../actions/auth";

const Login = ({
  isShowing,
  hide,
  openRegister,
  switched,
  login,
  forgot,
  isAuthenticated,
}) => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [isForgot, setIsForgot] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { email, password } = formData;
  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  // Keep the email between openings, but never leave a password behind.
  const reset = () => {
    setIsForgot(false);
    setShowPassword(false);
    setFormData((data) => ({ ...data, password: "" }));
  };

  const close = () => {
    reset();
    hide();
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) {
      return;
    }
    setIsSubmitting(true);
    if (isForgot) {
      const sent = await forgot(email);
      setIsSubmitting(false);
      if (sent) {
        setIsForgot(false);
      }
    } else if (!(await login(email, password))) {
      // On success the navbar swaps to signed-in links and unmounts this modal.
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (!isShowing) {
      return undefined;
    }
    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        close();
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  });

  // Redirect if logged in
  if (isAuthenticated) {
    return <Redirect to="/upload" />;
  }

  if (!isShowing) {
    return null;
  }
  return (
    <div
      id="auth-modal"
      className={`modal is-active dialog-modal ${switched ? "is-switched" : ""}`}
    >
      <div className="modal-background" onClick={close}></div>
      <div className="modal-content">
        <div
          className="dialog-box"
          role="dialog"
          aria-modal="true"
          aria-labelledby="login-title"
        >
          <button
            type="button"
            className="dialog-close"
            aria-label="Хаах"
            onClick={close}
          >
            <i className="fas fa-times" aria-hidden="true"></i>
          </button>

          <span className="dialog-icon" aria-hidden="true">
            <i className={`fas ${isForgot ? "fa-key" : "fa-user"}`}></i>
          </span>
          <h2 id="login-title">{isForgot ? "Нууц үг сэргээх" : "Нэвтрэх"}</h2>
          <p className="dialog-lead">
            {isForgot
              ? "Бүртгэлтэй имэйл хаягаа оруулна уу. Шинэ нууц үгийг тань имэйлээр илгээнэ."
              : "Cloud Print бүртгэлээрээ нэвтэрч файлаа хэвлээрэй."}
          </p>

          <form onSubmit={onSubmit}>
            <div className="field">
              <label className="dialog-label" htmlFor="login-email">
                Имэйл
              </label>
              <div className="control has-icons-left">
                <input
                  id="login-email"
                  type="email"
                  className="input"
                  name="email"
                  value={email}
                  placeholder="name@example.com"
                  autoComplete="email"
                  autoFocus
                  required
                  onChange={onChange}
                />
                <span className="icon is-left">
                  <i className="fas fa-envelope" aria-hidden="true"></i>
                </span>
              </div>
            </div>

            {!isForgot && (
              <div className="field">
                <div className="dialog-label-row">
                  <label className="dialog-label" htmlFor="login-password">
                    Нууц үг
                  </label>
                  <button
                    type="button"
                    className="dialog-link"
                    onClick={() => setIsForgot(true)}
                  >
                    Нууц үгээ мартсан уу?
                  </button>
                </div>
                <div className="control has-icons-left">
                  <input
                    id="login-password"
                    type={showPassword ? "text" : "password"}
                    className="input dialog-password-input"
                    name="password"
                    value={password}
                    placeholder="Нууц үгээ оруулна уу"
                    autoComplete="current-password"
                    required
                    onChange={onChange}
                  />
                  <span className="icon is-left">
                    <i className="fas fa-lock" aria-hidden="true"></i>
                  </span>
                  <button
                    type="button"
                    className="dialog-password-toggle"
                    aria-label={
                      showPassword ? "Нууц үгийг нуух" : "Нууц үгийг харуулах"
                    }
                    aria-pressed={showPassword}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <i
                      className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                      aria-hidden="true"
                    ></i>
                  </button>
                </div>
              </div>
            )}

            <button
              type="submit"
              className={`button is-fullwidth dialog-submit ${
                isSubmitting ? "is-loading" : ""
              }`}
              disabled={isSubmitting}
            >
              {isForgot ? "Шинэ нууц үг авах" : "Нэвтрэх"}
            </button>
          </form>

          <p className="dialog-footer">
            {isForgot ? (
              <button
                type="button"
                className="dialog-link"
                onClick={() => setIsForgot(false)}
              >
                <i className="fas fa-arrow-left" aria-hidden="true"></i>
                Нэвтрэх рүү буцах
              </button>
            ) : (
              <Fragment>
                Бүртгэл байхгүй юу?{" "}
                <button
                  type="button"
                  className="dialog-link"
                  onClick={() => {
                    reset();
                    openRegister();
                  }}
                >
                  Бүртгүүлэх
                </button>
              </Fragment>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

// The modal props are optional because the /login route also renders this bare.
Login.propTypes = {
  isShowing: PropTypes.bool,
  hide: PropTypes.func,
  openRegister: PropTypes.func,
  // Opened by the other auth dialog handing over, so it skips the opening animation
  switched: PropTypes.bool,
  login: PropTypes.func.isRequired,
  forgot: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, { login, forgot })(Login);
